import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function Servicos() {
  const { t } = useTranslation();
  const [expandedService, setExpandedService] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-instagram-line',
      titleKey: 'servicos.gestaoRedes',
      descKey: 'servicos.gestaoRedesDesc',
      detailsKey: 'servicos.gestaoRedesDetalhes',
      keywords: ['Instagram', 'Facebook', 'TikTok', 'engagement', 'seguidores']
    },
    {
      icon: 'ri-film-line',
      titleKey: 'servicos.producaoConteudo',
      descKey: 'servicos.producaoConteudoDesc',
      detailsKey: 'servicos.producaoConteudoDetalhes',
      keywords: ['fotografia', 'vídeo', 'audiovisual', 'produção', 'conteúdo visual']
    },
    {
      icon: 'ri-palette-line',
      titleKey: 'servicos.designGrafico',
      descKey: 'servicos.designGraficoDesc',
      detailsKey: 'servicos.designGraficoDetalhes',
      keywords: ['design', 'identidade visual', 'gráfico', 'brochuras', 'cartões']
    },
    {
      icon: 'ri-lightbulb-line',
      titleKey: 'servicos.branding',
      descKey: 'servicos.brandingDesc',
      detailsKey: 'servicos.brandingDetalhes',
      keywords: ['marca', 'branding', 'identidade', 'posicionamento', 'logotipo']
    },
    {
      icon: 'ri-rocket-line',
      titleKey: 'servicos.trafegoPago',
      descKey: 'servicos.trafegoPagoDesc',
      detailsKey: 'servicos.trafegoPagoDetalhes',
      keywords: ['Meta Ads', 'Google Ads', 'campanhas', 'conversão', 'ROI']
    },
    {
      icon: 'ri-line-chart-line',
      titleKey: 'servicos.estrategiaDigital',
      descKey: 'servicos.estrategiaDigitalDesc',
      detailsKey: 'servicos.estrategiaDigitalDetalhes',
      keywords: ['estratégia', 'marketing digital', 'planeamento', 'análise', 'crescimento']
    },
  ];

  if (typeof t !== 'function') {
    console.error('Translation function "t" is not available.');
    return null;
  }

  return (
    <section id="servicos" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6">
            {t('servicos.titulo')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('servicos.subtitulo')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
              onClick={() => setExpandedService(expandedService === index ? null : index)}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-black text-white rounded-lg mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-black mb-4">
                {t(service.titleKey)}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t(service.descKey)}
              </p>
              
              {expandedService === index && (
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed mb-4 text-sm">
                    {t(service.detailsKey)}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {service.keywords.map((keyword, idx) => (
                      <span
                        key={idx}
                        className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full"
                      >
                        {keyword}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              <button className="mt-4 text-sm font-semibold text-black hover:text-gray-700 transition-colors flex items-center gap-2 whitespace-nowrap">
                {expandedService === index ? (
                  <>
                    {t('servicos.verMenos')}
                    <i className="ri-arrow-up-s-line"></i>
                  </>
                ) : (
                  <>
                    {t('servicos.verMais')}
                    <i className="ri-arrow-down-s-line"></i>
                  </>
                )}
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white p-8 lg:p-12 rounded-lg shadow-lg">
          <h3 className="text-2xl lg:text-3xl font-bold text-black mb-6 text-center">
            {t('servicos.porqueEscolher')}
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-black text-white rounded-full mx-auto mb-4">
                <i className="ri-award-line text-xl"></i>
              </div>
              <h4 className="font-bold text-black mb-2">{t('servicos.experiencia')}</h4>
              <p className="text-gray-600 text-sm">{t('servicos.experienciaDesc')}</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-black text-white rounded-full mx-auto mb-4">
                <i className="ri-team-line text-xl"></i>
              </div>
              <h4 className="font-bold text-black mb-2">{t('servicos.equipa')}</h4>
              <p className="text-gray-600 text-sm">{t('servicos.equipaDesc')}</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-black text-white rounded-full mx-auto mb-4">
                <i className="ri-line-chart-line text-xl"></i>
              </div>
              <h4 className="font-bold text-black mb-2">{t('servicos.resultados')}</h4>
              <p className="text-gray-600 text-sm">{t('servicos.resultadosDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
